module.exports = __webpack_public_path__ + "img/mirror32.ca5e5751.jpg";